import axios from 'axios'
import type {HistoryRecord} from '../../history/data/mockHistory'
import {mapBriefingRowToHistoryRecord} from '../../promotions/services/briefingPromocoesApi'

export async function fetchBriefingStatus(signal?: AbortSignal): Promise<HistoryRecord[]> {
  const records: HistoryRecord[] = []
  let beforeId: string | undefined
  while (true) {
    const response = await axios.get('/briefing-promocoes/status', {
      params: {limit: 500, beforeId}, signal,
    })
    const {success, data, nextCursor} = response.data
    if (!success || !Array.isArray(data)) throw new Error('Não foi possível carregar o status das promoções.')
    records.push(...data.map(mapBriefingRowToHistoryRecord))
    if (nextCursor === null) return records
    const nextId = Number(nextCursor)
    if (!data.length || !Number.isSafeInteger(nextId) || nextId <= 0 ||
      (beforeId !== undefined && nextId >= Number(beforeId))) {
      throw new Error('Não foi possível carregar todas as promoções. Atualize para tentar novamente.')
    }
    beforeId = String(nextCursor)
  }
}
